<!-- Trip List -->
    <div class="card border-0 shadow-sm mx-3 mx-md-0" [ngStyle]="{'height': height}">
        <!-- Title & Price -->
        <header id="SVGwave1BottomShapeID2"
                class="card-header border-0 position-relative bg-{{headerColor}} text-white p-5"
                style="padding-bottom:6rem!important"
                [ngClass]="{'shadowed' : hasTextShadow}">
            <h3 class="h4 mb-1">{{titleString}} </h3>
            <h1 class="mb-1"><app-fa-icon iconName="map-signs"></app-fa-icon></h1>
            <span class="d-block pb-5 pt-2 pb-sm-2">
              {{subtitleString}}
            </span>
            <div class="position-absolute left-0 left-0 w-100" style="bottom:-1px;">
                <figure class="ie-wave-1-bottom">
                    <img src="../assets/svg/components/wave-1-bottom.svg"
                         alt="SVG Wave"
                         class="w-100"
                         data-parent="#SVGwave1BottomShapeID2">
                </figure>
            </div>
        </header>
        <!-- End Title & Price -->

        <!-- Listing -->
        <div class="card-body pt-0 px-3 pb-5 text-dark">
            <ul class="list-group list-group-flush list-group-borderless py-2">

                <ng-container *ngIf="!entries">
                    <h1 class="text-warning"> MISSING TRIP ENTRY DATA! </h1>
                    <h5 class="text-warning">add the 'entries' parameter to &lt;app-trip-list&gt;!</h5>
                </ng-container>

                <ng-container *ngIf="entries">
                    <ng-container *ngFor="let entry of entries">

                        <!-- Template for trip entry -->
                        <li class="list-group-item pb-1">
                            <div class="d-flex align-items-center linkGroup">
                                <a *ngIf="entry.iconName" appCuteIcon class="mr-3 px-2-5 px-xl-0" [type]="entry.iconName" sizeInPixels="64"
                                   [routerLink]="entry.route"></a>
                              <span *ngIf="!entry.iconName" [routerLink]="entry.route" class="btn btn-sm btn-icon btn-soft-dark rounded-circle mr-3 px-2-5 px-xl-0">
                                <a><app-fa-icon iconName="bookmark" color="black" classes="bookmark" width="1" height="1"></app-fa-icon></a></span>
                                <a style="display:inline" class="link tripLink" [routerLink]="entry.route">
                                    <h4>{{entry.title}}</h4>
                                </a>
                            </div>
                        </li>

                    </ng-container>
                </ng-container>
            </ul>
        </div>
        <!-- End Listing -->
    </div>
<!-- End Trip List -->
